import { render, staticRenderFns } from "./user_plus.vue?vue&type=template&id=b9e0f3ec"
import script from "./user_plus.vue?vue&type=script&lang=js"
export * from "./user_plus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_2wi5n7v5trihbigbnnizsbscmu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports